import { useEffect, useState } from 'react';

function computePosition(element) {
  const rect = element.getBoundingClientRect();
  const width = rect.width;
  const left = Math.max(8, Math.min(rect.left, window.innerWidth - width - 8));

  const spaceBelow = window.innerHeight - rect.bottom;
  const spaceAbove = rect.top;
  const openUp = spaceBelow < 260 && spaceAbove > spaceBelow;

  if (openUp) {
    return {
      placement: 'top',
      left,
      width,
      bottom: Math.max(8, Math.min(window.innerHeight - rect.top + 6, window.innerHeight - 8)),
    };
  }

  return {
    placement: 'bottom',
    left,
    width,
    top: Math.max(8, Math.min(rect.bottom + 6, window.innerHeight - 8)),
  };
}

function useFixedOverlayPosition(anchorRef, open) {
  const [pos, setPos] = useState(null);

  useEffect(() => {
    if (!open) return;
    const anchor = anchorRef.current;
    if (!anchor) return;

    const update = () => {
      const el = anchorRef.current;
      if (!el) return;
      setPos(computePosition(el));
    };

    update();
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
    };
  }, [anchorRef, open]);

  return pos;
}

export default useFixedOverlayPosition;

